module.exports = __webpack_public_path__ + "img/l-0.8f78308.png";